/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-26 10:30:32
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-22 03:56:35
 */

const guidance = {
  tab: ['商务合作', '其他合作'],
  des: '业务合作类，如业务需求、落地场景、所需产品功能等描述',
  form: {
    username: {
      label: '联系人'
    },
    telephone: {
      label: '联系电话'
    },
    email: {
      label: '联系邮箱'
    },
    company: {
      label: '公司名称'
    },
    address: {
      label: '所在地'
    },
    consult: {
      label: '咨询问题'
    },
    btn: '提交'
  },
  cards: [
    {
      label: '商务合作',
      des: '邮箱：yuhao.zhou@arteryflow.com'
    },
    {
      label: '投融资合作',
      des: '邮箱：lei.zhang@arteryflow.com'
    },
    {
      label: '媒体合作',
      des: '邮箱：luyao.shen@arteryflow.com'
    },
    {
      label: '代理商自荐',
      des: '邮箱：ruixue.li@arteryflow.com'
    },
    {
      label: '举办投诉',
      des: '邮箱：shihe.li@arteryflow.com'
    },
    {
      label: '问题反馈',
      des: '邮箱：yongkuan.yang@arteryflow.com'
    }
  ]
}

export default guidance
